import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Calendar, User, TrendingUp } from 'lucide-react';

interface Project {
  id: string;
  name: string;
  status: 'active' | 'completed' | 'on-hold';
  progress: number;
  owner: string;
  targetDate: string;
  healthScore: number;
}

const mockProjects: Project[] = [
  {
    id: 'proj-001',
    name: 'Enterprise CRM Implementation',
    status: 'active',
    progress: 65,
    owner: 'Sarah Chen',
    targetDate: '2024-04-30',
    healthScore: 85
  },
  {
    id: 'proj-002',
    name: 'Cloud Migration - Phase 1',
    status: 'active',
    progress: 25,
    owner: 'Alex Kumar',
    targetDate: '2024-06-15',
    healthScore: 92
  }
];

export const ProjectsList: React.FC = () => {
  const [projects] = useState<Project[]>(mockProjects);

  const handleOpenOnboarding = (projectId: string) => {
    window.open(`/beehive/control-bridge/onboarding/${projectId}`, '_blank');
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-white">Projects</h1>
      </div>

      <div className="geex-card backdrop-blur-md border border-slate-700/50 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-slate-800/50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">
                  Project
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">
                  Progress
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">
                  Owner
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">
                  Target Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-700/50">
              {projects.map((project) => (
                <motion.tr
                  key={project.id}
                  whileHover={{ backgroundColor: 'rgba(51, 65, 85, 0.3)' }}
                  className="transition-colors"
                >
                  <td className="px-6 py-4">
                    <div>
                      <div className="text-sm font-medium text-white">{project.name}</div>
                      <div className="text-sm text-slate-400">Status: {project.status}</div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      <div className="w-16 bg-slate-700 rounded-full h-2 mr-2">
                        <div
                          className="bg-gradient-to-r from-[#4267A1] to-[#5A7BC4] h-2 rounded-full"
                          style={{ width: `${project.progress}%` }}
                        />
                      </div>
                      <span className="text-sm text-white">{project.progress}%</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-300">
                    {project.owner}
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-300">
                    {new Date(project.targetDate).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => handleOpenOnboarding(project.id)}
                      className="flex items-center text-[#7bb8ff] hover:text-[#5A7BC4] transition-colors"
                    >
                      <span className="text-sm font-medium">Open Onboarding</span>
                      <ExternalLink className="w-4 h-4 ml-1" />
                    </button>
                  </td>
                </motion.tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProjectsList;
